<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="displayText"
        :label="label"
        append-icon="mdi-calendar"
        readonly
        outlined
        dense
        hide-details
        clearable
        v-bind="attrs"
        v-on="on"
        @click:clear="clear"
      />
    </template>
    <v-date-picker v-model="range" range color="primary" :max="max">
      <v-spacer />
      <v-btn text @click="menu = false">{{ $t("cancel") }}</v-btn>
      <v-btn text color="primary" @click="apply">{{ $t("apply") }}</v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "DateRangeField",
  props: {
    // v-model: [fromISO, toISO]
    value: { type: Array, default: () => [] },
    label: { type: String, default: "" },
    max: { type: String, default: undefined },
  },
  data() {
    return {
      menu: false,
      range: Array.isArray(this.value) ? [...this.value] : [],
    };
  },
  computed: {
    displayText() {
      if (this.range.length === 2) return `${this.range[0]} ~ ${this.range[1]}`;
      if (this.range.length === 1) return this.range[0];
      return "";
    },
  },
  watch: {
    value(nv) {
      this.range = Array.isArray(nv) ? [...nv] : [];
    },
  },
  methods: {
    apply() {
      // v-date-picker range can return dates out of order — normalize ascending.
      const sorted = [...this.range].sort();
      this.range = sorted;
      this.menu = false;
      this.$emit("input", sorted);
      this.$emit("change", { from: sorted[0] || null, to: sorted[1] || null });
    },
    clear() {
      this.range = [];
      this.$emit("input", []);
      this.$emit("change", { from: null, to: null });
    },
  },
};
</script>
